import { Effect } from "../Materials/effect";
var name = 'clearQuadVertexShader';
var shader = "\nconst pos : array<vec2<f32>,4>\n= array<vec2<f32>,4>(\nvec2<f32>(-1.0,1.0),\nvec2<f32>(1.0,1.0),\nvec2<f32>(-1.0,-1.0),\nvec2<f32>(1.0,-1.0)\n);\n[[builtin(position)]] var<out> position : vec4<f32>;\n[[builtin(vertex_idx)]] var<in> vertexIndex : i32;\n[[stage(vertex)]]\nfn main() -> void {\nposition=vec4<f32>(pos[vertexIndex],0.0,1.0);\nreturn;\n}\n";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var clearQuadVertexShader = { name: name, shader: shader };
//# sourceMappingURL=clearQuad.vertex.js.map